import { Button, Cascader, DatePicker, Flex, Form, Input, InputNumber, Modal, Select, TreeSelect, Upload } from "antd";
import React, { useState, useEffect } from "react";
import CustomIcon from "../Icons/CustomIcon";
import { useTranslation } from "react-i18next";
import moment from "moment";

const { TextArea } = Input;
const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const SubmitButton = ({ form }) => {
  const [submittable, setSubmittable] = React.useState(false);

  // Watch all values
  const values = Form.useWatch([], form);
  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: false,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        },
      );
  }, [values]);
  return (
    <Button type="primary" htmlType="submit" disabled={!submittable} className='ant-btn-blue -small'>
      Submit
    </Button>
  );
};

export const FormModal = ({ data, onFinish, handleUpload }) => {
  // const onFinish = (values) => {
  //   onFinish(values)
  // };
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [base64File, setBase64File] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [dataToSend, setDataToSend] = useState(null);

  const handleBeforeUpload = (file) => {
    try {
      getBase64(file).then((base64) => {
        setBase64File(base64);
      });
      setFileName(file?.name)
    } catch (error) {
      console.error('(FormModal) Failed to convert file to base64');
    }
    return false; // Prevent default upload behavior
  };

  const getBase64 = (file) => {
    try {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    } catch (error) {
      console.error('(FormModal) Error getting base64 file', error);
    }
  };

  const onFinishObj = (values) => {
    try {
      let dataToSend = values;
      
      if (base64File) {
        setDataToSend({ ...dataToSend, expirationDate: moment(values?.date?.$d).format('YYYY-MM-DD'), uploadFile: base64File, fileName: fileName })
      } else {
        setDataToSend({ ...dataToSend })
      }
    } catch (error) {
      console.error('(FormModal) Error setting object data', error);
    }
  };

  useEffect(() => {
    try {
      if (dataToSend) {
        onFinish(dataToSend);
        form.resetFields();
      }
    } catch (error) {
      console.error('(FormModal) Error passing onFinish data', error);
    }

  }, [dataToSend]);
  return (
    <Form
      labelCol={{ span: data?.layout?.labelCol ?? 6 }}
      wrapperCol={{ span: data?.layout?.wrapperCol ?? 12 }}
      layout={data?.layout?.layout ?? "horizontal"}
      onFinish={(e) => { onFinishObj(e) }}
    >
      {data?.items.map((item, index) => {
        switch (item?.input) {
          case 'number':
            return <Form.Item label={item?.label} name={item?.name} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <InputNumber />
            </Form.Item>
          case 'date':
            return <Form.Item label={item?.label} name={item?.name} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <DatePicker disabledDate={item?.minDate ?? false} format={item?.formatDate ?? 'DD/MM/YYYY'} />
            </Form.Item>
          case 'select':
            return <Form.Item label={item?.label} name={item?.name} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <Select >
                {item?.options.map(el =>
                  <Select.Option value={el}>{el}</Select.Option>
                )}
              </Select>
            </Form.Item>
          case 'upload':
            return <Form.Item label={item?.label} name={item?.name} valuePropName={item?.valuePropName} getValueFromEvent={normFile} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <Upload beforeUpload={handleBeforeUpload} maxCount={item?.maxFiles}>
                <Button shape="circle" icon={<CustomIcon icon={'Upload'} iconsize='sm' color='blue-4' />} />
              </Upload>
            </Form.Item>
          case 'input':
            return <Form.Item label={item?.label} name={item?.name} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <Input />
            </Form.Item>
          case 'multipleSelect':
            return <Form.Item label={item?.label} name={item?.name} key={item?.key}
              rules={[
                {
                  required: item?.required,
                },
              ]}>
              <Select
                mode="multiple">
                {item?.options.map(el =>
                  <Select.Option value={el} checked={el === item?.name}>{el}</Select.Option>
                )}
              </Select>
            </Form.Item>
          default:
        }

      })}

      <Form.Item
        wrapperCol={{
          offset: 16,
          span: 8,
        }}
        key='buttons'
      >
        <Flex gap={16} justify="flex-end" horizontal="true">
          <Button htmlType="reset">Reset</Button>
          <SubmitButton form={form} />
        </Flex>
      </Form.Item>
    </Form>
  );
};
